import LeftSide from './LeftSide'
import RightSide from './RightSide'

export default {
  LeftSide,
  RightSide,
}